import { useEffect, useRef } from "react";

/**
 * Infinite right-to-left auto-scrolling carousel.
 * Items are duplicated so the translateX loop is seamless.
 * Pauses on hover.
 */
export default function ProductCarousel({ items, height = 280, gap = 16, speed = 38, testId }) {
  const trackRef = useRef(null);
  // Duplicate the items so the loop seems endless
  const loopItems = [...items, ...items];

  return (
    <div
      className="relative overflow-hidden border border-border bg-card/20"
      data-testid={testId}
    >
      <div
        ref={trackRef}
        className="flex animate-marquee hover:[animation-play-state:paused]"
        style={{
          gap: `${gap}px`,
          animationDuration: `${speed}s`,
        }}
      >
        {loopItems.map((p, i) => (
          <a
            key={`${p.id}-${i}`}
            href={`mailto:ironcladatx@gmail.com?subject=Order%20-%20${encodeURIComponent(
              p.name
            )}`}
            className="flex-shrink-0 relative group"
            style={{ height, width: Math.round(height * 1.05) }}
            data-testid={`carousel-item-${i}`}
          >
            <img
              src={p.image}
              alt={p.name}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <div className="text-[10px] uppercase tracking-widest text-primary">
                {p.category.replace(/_/g, " ")}
              </div>
              <div className="font-display text-sm font-bold uppercase tracking-tight text-white leading-tight line-clamp-2">
                {p.name}
              </div>
              <div className="font-display text-base font-black text-primary mt-0.5">
                ${p.price.toFixed(2)}
              </div>
            </div>
          </a>
        ))}
      </div>
      {/* fade edges */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}
